import {
  AccountBalance,
  ConfirmationNumber,
  Payments,
  ReceiptLong,
  Schedule,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { anyOf, reads, records } from '../../util/access';
import WorkspaceHub, { type HubSection } from './WorkspaceHub';

const CashHub = () => {
  const { t } = useTranslation();

  const sections: HubSection[] = [
    {
      id: 'out',
      title: t('common:hubs.sections.moneyOut'),
      cards: [
        {
          id: 'expenses',
          title: t('nav:tabs.expenses'),
          description: t('common:hubs.cards.expenses'),
          path: '/expenses',
          grant: reads('expense'),
          color: '#6d4c41',
          icon: ReceiptLong,
        },
        {
          id: 'vouchers',
          title: t('nav:tabs.vouchers'),
          description: t('common:hubs.cards.vouchers'),
          path: '/vouchers',
          grant: reads('voucher'),
          color: '#c62828',
          icon: ConfirmationNumber,
        },
        {
          id: 'supply-payments',
          title: t('nav:tabs.supply_payments'),
          description: t('common:hubs.cards.supplyPayments'),
          path: '/supply-payments',
          grant: reads('supply_payment'),
          color: '#6a1b9a',
          icon: Payments,
        },
      ],
    },
    {
      id: 'cashup',
      title: t('common:hubs.sections.cashUp'),
      cards: [
        {
          id: 'deposits',
          title: t('nav:tabs.deposits'),
          description: t('common:hubs.cards.deposits'),
          path: '/deposits',
          grant: anyOf(reads('deposit'), records('deposit')),
          color: '#1565c0',
          icon: AccountBalance,
        },
        {
          id: 'pending-deposits',
          title: t('nav:tabs.pending_deposits'),
          description: t('common:hubs.cards.pendingDeposits'),
          path: '/deposits/pending',
          grant: anyOf(reads('deposit'), records('deposit')),
          color: '#ef6c00',
          icon: Schedule,
        },
      ],
    },
  ];

  return (
    <WorkspaceHub
      title={t('nav:tabs.cash')}
      subtitle={t('common:hubs.cashSubtitle')}
      sections={sections}
    />
  );
};

export default CashHub;
